import Vue from 'vue';
import WebTracing from '@front_core/web-tracing-vue2';
import { pick, omit } from 'lodash';
import { appver } from '@/common/script/unit';
import { clientType, action } from '@/appApi';

const LOG_MAX_LENGTH = clientType() !== 'ios' ? 8000 : 25000;

const formatEvent = (event: any) => {
  // 接口事件
  if (event.eventId === 'server' && event.eventType === 'performance') {
    if (!event.requestUrl || !event.requestUrl.startsWith('https://')) return undefined;
    // 只取header中utk和dut
    const filteredHeaders = event.headers ? pick(JSON.parse(event.headers), ['x-dut', 'x-utk']) : {};
    const formattedEvent: Record<string, string> = {
      type: 'request',
      duration: event.duration,
      method: event.requestMethod,
      url: event.requestUrl,
      page: event.triggerPageUrl,
      status: event.responseStatus,
    };
    if (Object.keys(filteredHeaders).length > 0) {
      formattedEvent.headers = JSON.stringify(filteredHeaders);
    }
    if (Object.keys(event.params).length > 0) {
      formattedEvent.params = event.params;
    }
    formattedEvent.response = event.responseContent;
    return formattedEvent;
  }
  // 页面事件
  if (event.eventType === 'pv') {
    return {
      type: 'page',
      url: event.triggerPageUrl,
    };
  }
  // 错误事件，去除错误堆栈(没有sourcemap无法解析，且很大)
  if (event.eventType === 'error' && event.errMessage) {
    return {
      type: 'error',
      message: event.errMessage,
      page: event.triggerPageUrl,
    };
  }
  return undefined;
};

export const initWebTracing = () => {
  const version = appver();
  if (!version || version === 0) {
    return;
  }
  if (!((clientType() === 'ios' && version >= 111101) || clientType() === 'harmony' || (clientType() === 'android' && version >= 111102))) {
    return;
  }
  Vue.use(WebTracing, {
    dsn: 'empty',
    appName: 'diyi-applinedweb',
    debug: process.env.VUE_APP_SERVER !== 'prodServer',
    pv: true,
    performance: true,
    error: true,
    event: { core: true },
    recordScreen: false,
    cacheMaxLength: 100,
    cacheWatingTime: 100,
    scopeError: true,
    tracesSampleRate: 1,

    ignoreErrors: [/\[Vue warn\]:/],
    ignoreRequest: [/only_user_info/, /logstores\/newplayer\/track/, /sockjs-node/],
    beforeSendData(data: any) {
      const newData = data.eventInfo.map(formatEvent).filter(Boolean);
      let prevEvent: any = null;
      let prevType = '';
      // 去除连续的重复事件
      newData.forEach((event: any) => {
        const jsonString = JSON.stringify(omit(event, 'type'));
        if (prevEvent !== jsonString || prevType !== event.type) {
          const command = {
            command: 'writeLog',
            tag: 'H5_' + event.type,
            log: jsonString.slice(0, LOG_MAX_LENGTH),
          };
          action(command);
          prevEvent = jsonString;
          prevType = event.type;
        }
      });
      // 返回false代表sdk不发送
      return false;
    },
  });
};
